// Navbar.js
import styles from "./styles/Navbar.module.css";
import { useTheme, useLanguage } from "./ThemeContext";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import ProTheme from "./styles/PRO/Navbar.module.css";
import UNSWTheme from "./styles/UNSW/Navbar.module.css";
import MQUTheme from "./styles/MQU/Navbar.module.css";
import UMelbTheme from "./styles/UMelb/Navbar.module.css";

import proLogo from "./img/logo/pro.png";
import unswLogo from "./img/logo/unsw.png";
import umelbLogo from "./img/logo/umelb.png";
import mquLogo from "./img/logo/unsw.png";

import { Spin as Hamburger } from "hamburger-react";

import wordsJson from "./words.json";

import { AnimatePresence, motion } from "framer-motion";

function Navbar() {
  // Language Changer
  const { changeToEnglish, changeToChinese } = useLanguage();
  const { language } = useLanguage();
  const [wordsContent, setWordsContent] = useState(
    wordsJson.admin[language].navigationSection
  );

  // Theme Changer
  const { theme } = useTheme();

  const themes = {
    Pro: { styles: ProTheme, logo: proLogo },
    UNSW: { styles: UNSWTheme, logo: unswLogo },
    UMelb: { styles: UMelbTheme, logo: umelbLogo },
    MQU: { styles: MQUTheme, logo: mquLogo },
    default: { styles: ProTheme, logo: proLogo },
  };

  function getThemeSettings(theme) {
    return themes[theme] || themes.default;
  }

  const { styles: themeStyles, logo } = getThemeSettings(theme);
  const [currentTheme, setCurrentTheme] = useState(wordsContent.proSocName);

  useEffect(() => {
    setWordsContent(wordsJson.admin[language].navigationSection);
    switch (theme) {
      case "Pro":
        setCurrentTheme(wordsJson.admin[language].navigationSection.proSocName);
        break;
      case "UNSW":
        setCurrentTheme(
          wordsJson.admin[language].navigationSection.unswSocName
        );
        break;
      case "UMelb":
        setCurrentTheme(
          wordsJson.admin[language].navigationSection.melbSocName
        );
        break;
      case "MQU":
        setCurrentTheme(wordsJson.admin[language].navigationSection.mquSocName);
        break;
      default:
        setCurrentTheme(wordsJson.admin[language].navigationSection.proSocName);
    }
  }, [language, theme]);

  const navigate = useNavigate(); // Get navigate function
  
  const handleThemeChange = (changeTheme, theme) => {
    navigate(`/${changeTheme}`); // Navigate to the theme-based route
  };

  const handleLanguageChange = () => {
    if (language === "English") {
      changeToChinese();
    } else {
      changeToEnglish();
    }
  };

  // Dropdown menu open until click outside
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Scroll to a section by ID
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <section className={`${styles.navbar} ${themeStyles.navbar}`}>
      <div className={`${styles.logo} ${themeStyles.logo}`}>
        <img
          src={logo}
          alt="发消息AWSUNSW微信小助手 id:aws__unsw (Note 有id有两个下划线), 告诉他你要找Tong Zhou, 对这个网站Project感兴趣"
        />

        <div
          className={`${styles.themeDropdown} ${themeStyles.themeDropdown} ${
            isDropdownOpen ? styles.open : ""
          } ${isDropdownOpen ? themeStyles.open : ""}`}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <button
            className={`${styles.themeDropdownButton} ${themeStyles.themeDropdownButton}`}
          >
            {wordsContent.socName}
            {currentTheme}
          </button>
          <AnimatePresence>
            {isDropdownOpen && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className={`${styles.themeDropdownContainer} ${themeStyles.themeDropdownContainer}`}
              >
                {currentTheme !== wordsContent.proSocName && (
                  <div>
                    <button
                      className={`${styles.themeButton} ${ProTheme.themeButton}`}
                      onClick={() =>
                        handleThemeChange("pro", wordsContent.proSocName)
                      }
                    >
                      {wordsContent.proSocName}
                    </button>
                  </div>
                )}
                {currentTheme !== wordsContent.unswSocName && (
                  <div>
                    <button
                      className={`${styles.themeButton} ${UNSWTheme.themeButton}`}
                      onClick={() =>
                        handleThemeChange("unsw", wordsContent.unswSocName)
                      }
                    >
                      {wordsContent.unswSocName}
                    </button>
                  </div>
                )}
                {currentTheme !== wordsContent.melbSocName && (
                  <div>
                    <button
                      className={`${styles.themeButton} ${UMelbTheme.themeButton}`}
                      onClick={() =>
                        handleThemeChange("umelb", wordsContent.melbSocName)
                      }
                    >
                      {wordsContent.melbSocName}
                    </button>
                  </div>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      <div className={styles.menuButton}>
        <button
          onClick={handleLanguageChange}
          className={`${styles.translationButtonPhone} ${themeStyles.translationButtonPhone}`}
        >
          {language === "English" ? "English" : "中文"}
        </button>
        <Hamburger size={25} toggled={menuOpen} toggle={setMenuOpen} />
      </div>

      <div className={styles.buttonsBox}>
        <div className={styles.translationButton}>
          <button
            onClick={handleLanguageChange}
            className={`${styles.translationButtonLaptop} ${themeStyles.translationButtonLaptop}`}
          >
            {language === "English" ? "English" : "中文"}
          </button>
        </div>

        <div
          className={`${styles.tabs} ${menuOpen ? styles.open : styles.close}`}
        >
          <input
            id="MemberPortal"
            type="radio"
            name="tabMenu"
            className={styles.input}
            onClick={() => navigate("/member/login")}
          />
          <div className={`${styles.buttons} ${themeStyles.buttons}`}>
            <label
              htmlFor="MemberPortal"
              className={`${styles.label} ${themeStyles.label}`}
            >
              {wordsContent.memberPortalNav}
            </label>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Navbar;
